import React from 'react'

const Label = ({children, className}) => {
    return (
        <h5 className={`uppercase subtitle mb-2 ${className ? className : ""}`}>{children}</h5>
    )
}

export default Label